module.exports = __webpack_public_path__ + "static/media/census-app_2screen.48eb420c.png";